import { ACTION_TASK_CONSTANTS } from "@/modules/Dashboards/AdminDashboard/constants/ActionConstants";
import { ActionError } from "@/modules/Dashboards/AdminDashboard/models/ActionTask";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { SNACKBAR_STYLE } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";

Vue.use(Vuetify);

@Component({
  name: "ActionTabsError",
  components: {
    EmptyState
  }
})
export default class ActionTabsError extends Vue {
  @Prop() errors!: ActionError[];
  @Prop() success!: ActionError[];

  LABELS = ACTION_TASK_CONSTANTS.LABELS;

  tab = 0;
  tabs = [
    ACTION_TASK_CONSTANTS.LABELS.ITEMS_WITH_ERRORS + this.errors.length,
    ACTION_TASK_CONSTANTS.LABELS.ITEMS_SUCCESS + this.success.length
  ];

  get iconColor() {
    return this.tab == 0
      ? SNACKBAR_STYLE.ERROR.COLOR
      : SNACKBAR_STYLE.SUCCESS.COLOR;
  }
  get icon() {
    return this.tab == 0
      ? SNACKBAR_STYLE.ERROR.ICON
      : SNACKBAR_STYLE.SUCCESS.ICON;
  }

  get listError() {
    return this.tab == 0 ? this.errors : this.success;
  }
}
